import { renderToString } from "react-dom/server";

export const getText = (node) => {
  const txt = renderToString(node);

  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(txt, "text/html");
  return htmlDoc.documentElement.textContent;
};
